import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext } from 'react';

const BlockingPopup: FC = () => {
  const store = useContext(NolPromotionStoreCtx);

  return (
    <Popup
      isOpen={store.isPopupBlockModalOpen}
      mainBtn={{
        label: '닫기',
        onClick: () => (store.isPopupBlockModalOpen = false),
      }}
    >
      {{ title: '브라우저 설정에서 팝업 차단 기능을 해제한 후 다시 시도해주세요.\n' }}
    </Popup>
  );
};

export default observer(BlockingPopup);
